import React from 'react'
import pretty from 'pretty-bytes'
import classnames from 'classnames'
import { useSelector } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import Chip from '@material-ui/core/Chip'
import Divider from '@material-ui/core/Divider'
import Tooltip from '@material-ui/core/Tooltip'

import Button from '@material-ui/core/Button'
import Card from '@material-ui/core/Card'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'

import appsumoSelectors from 'store/selectors/appsumo'
import stripeSelectors from 'store/selectors/stripe'
import userSelectors from 'store/selectors/user'
import priceUtils from 'utils/price'

import {
  PRODUCT_FEATURES,
} from 'settings'

const useStyles = makeStyles(theme => ({
  card: {
    
  },
  title: {
    
  },
  subtitle: {
    //marginBottom: 12,
  },
  description: {
    
  },
  featureContainer: {
    marginTop: theme.spacing(2),
  },
  featureTitle: {
    textAlign: 'right',
    marginRight: theme.spacing(1),
    fontSize: '0.8em',
  },
  featureContent: {
    textAlign: 'left',
    fontSize: '0.9em',
    fontWeight: '500',
  },
  featureContentIcon: {
    fontSize: '1em',
  },
  tick: {
    color: '#009900',
  },
  cross: {
    color: '#990000',
  },
  badge: {
    textAlign: 'right',
  },
  selectedText: {
    color: theme.palette.secondary.main,
  },
  divider: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  dividerTop: {
    marginTop: theme.spacing(2),
  }
}))

const AppsumoPlans = ({
  spacing = 1,
}) => {
  const classes = useStyles()
  
  const plans = useSelector(appsumoSelectors.plans)
  const user = useSelector(userSelectors.data)
  const products = useSelector(stripeSelectors.productList)
  const activePlan = plans.find(plan => plan.id == user.appsumo_plan)

  const ultimateProduct = products.find(product => product.metadata.nocodeId == 'ultimate')

  return (
    <Grid
      container
      spacing={ spacing }
      direction="row"
      justify="center"
      alignItems="stretch"
    >
      {
        plans.map((plan) => {

          const isActivePlan = activePlan && activePlan.id == plan.id

          const activateTitle = activePlan && plan.level > activePlan.level ?
            'Enhance' :
            'Reduce'

          const activateVariant = activePlan && plan.level > activePlan.level ?
            'contained' :
            'outlined'

          const activateColor = activePlan && plan.level > activePlan.level ?
            'secondary' :
            'default'

          return (
            <Grid item key={ plan.id } xs={ 12 } sm={ 12 } md={ 2 }>
              <Card className={ classes.card } elevation={ isActivePlan ? 10 : 2 }>
                <CardContent>
                  <Typography
                    className={ classnames(classes.title, {
                      [classes.selectedText]: isActivePlan,
                    }) } 
                    variant="h6"
                    component="h2"
                  >
                    { plan.title }
                  </Typography>
                  <Typography className={ classes.subtitle } color="textSecondary">
                    ${ priceUtils.displayPrice(plan.price * 100) } / lifetime deal
                  </Typography>
                  <Typography className={ classes.subtitle } color="textSecondary">
                    websites:
                    <strong
                      className={ classnames({
                        [classes.selectedText]: isActivePlan,
                      }) } 
                    >
                      { plan.websites }
                    </strong>
                  </Typography>
                  <Divider className={ classes.divider } />
                  {
                    ultimateProduct && (
                      <div className={ classes.featureContainer }>
                        <Grid container spacing={ 0 }>
                          {
                            PRODUCT_FEATURES.map(feature => {
                              const value = ultimateProduct.metadata[feature.id]
                              let content = value
                              
                              if(feature.type == 'tick') {
                                content = value == 'on' ?
                                  <span className={ classes.tick }>✔</span> :
                                  <span className={ classes.cross }>✗</span>
                              }
                              else if(feature.type == 'bytes') {
                                content = pretty(content)
                              }

                              const contentClassname = classnames(classes.featureContent, {
                                [classes.featureContentIcon]: feature.type == 'tick',
                              })

                              return (
                                <React.Fragment key={ feature.id }>
                                  <Grid item xs={ 6 }>
                                    <Tooltip title={ feature.description } placement="top">
                                      <div className={ classes.featureTitle }>
                                        { feature.title }:
                                      </div>
                                    </Tooltip>
                                  </Grid>
                                  <Grid item xs={ 6 }>
                                    <Tooltip title={ feature.description } placement="top">
                                      <div className={ contentClassname }>
                                        { content } { feature.append || '' }
                                      </div>
                                    </Tooltip>
                                  </Grid>
                                </React.Fragment>
                              )
                            })
                          }
                        </Grid>
                      </div>
                    )
                  }
                  <Divider className={ classes.dividerTop } />
                </CardContent>
                <CardActions>
                  
                  {
                    isActivePlan ? (
                      <div className={ classes.badge }>
                        <Chip
                          label="ACTIVE"
                          color="secondary"
                          variant="outlined"
                        />
                      </div>
                    ) : (
                      <Button
                        size="small"
                        color={ activateColor }
                        variant={ activateVariant }
                        onClick={ () => {
                          const url = `https://appsumo.com/account/redemption/${user.appsumo_invoice_item_uuid}#change-plan`
                          window.open(url)
                        } }
                      >
                        { activateTitle }
                      </Button>
                    )
                  }
                </CardActions>
              </Card>
            </Grid>
          )
        })
      }
    </Grid>
  )
}

export default AppsumoPlans